import { z } from "zod";
import { memberDueStatusSchema } from "./collections.js";

/* ===========================================================================
 * US-E6.F9-0047 — Members Payment Status (@UC0060)
 * GET /v1/collections/:id/members-status — danh sách member + trạng thái đóng.
 *
 * PRIVACY (AC3): item CHỈ name + avatar + status. KHÔNG có amountMinor/số tiền của
 * người khác — enforce bằng SHAPE (field không tồn tại). Read-only, KHÔNG ledger.
 * ========================================================================= */

/** 1 member + trạng thái đóng (KHÔNG số tiền — AC3 privacy). */
export const memberPaymentStatusItemSchema = z
  .object({
    groupMemberId: z.string().uuid(),
    memberName: z.string().nullable(),
    avatarUrl: z.string().url().nullable(),
    status: memberDueStatusSchema,
  })
  .strict();

export type MemberPaymentStatusItem = z.infer<
  typeof memberPaymentStatusItemSchema
>;

export const membersPaymentStatusResponseSchema = z
  .object({
    collectionId: z.string().uuid(),
    members: z.array(memberPaymentStatusItemSchema),
    nextCursor: z.string().nullable(),
  })
  .strict();

export type MembersPaymentStatusResponse = z.infer<
  typeof membersPaymentStatusResponseSchema
>;
